import { globalShortcuts } from "@/input/shortcuts/globalShortcuts";
import { groupShortcuts } from "@/input/shortcuts/groupShortcuts";
import { movementShortcuts } from "@/input/shortcuts/movementShortcuts";
import { parameterShortcuts } from "@/input/shortcuts/parameterShortcuts";
import { selectionShortcuts } from "@/input/shortcuts/selectionShortcuts";
import { wrapShortcuts } from "@/input/shortcuts/wrapShortcuts";

import { type KeyboardInputAction } from "../types";

export const shortcuts = {
  ...globalShortcuts,
  ...movementShortcuts,
  ...selectionShortcuts,
  ...groupShortcuts,
  ...parameterShortcuts,
  ...wrapShortcuts,
} as Partial<Record<string, KeyboardInputAction>>;
